var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pages agree_container"},[(_vm.app === 'hsjpro')?_c('hsjpro-priacy'):_vm._e(),_c('hsj-priacy')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }